
import Vue from "vue";

export default Vue.extend({
  name: "App",
  components: {},
  data: () => ({}),
  computed: {
    areaName(): string {
      return this.$route?.meta?.title || "";
    }
  },
  methods: {
    setTitle(newTitle: string): void {
      if (!newTitle) {
        newTitle = this.areaName || "Página Inicial";
      }

      document.title = "SBT Ads - " + newTitle;
    }
  },
  watch: {
    $route(to: UnknownObj) {
      this.setTitle(to?.meta?.title);
    }
  },
  created() {
    this.setTitle(this.areaName);
  }
});
